import BaseService from 'services/BaseService';
import moment from 'moment';

//-------------------------------------------------------------------------------------------------------------------

export default class LocationService
    extends BaseService {

    static async listCountries(param) {
        return BaseService.callAPI('location/list-countries', param);
    }

    static async getCountry(id) {
        return BaseService.callAPI('location/get-country/' + id);
    }

    static async saveCountry(param) {
        return BaseService.callAPI('location/save-country', param);
    }

    static async deleteCountry(id) {
        return BaseService.callAPI('location/delete-country/' + id);
    }

    static async listCities(param) {
        return BaseService.callAPI('location/list-cities', param);
    }

    static async addCity(city) {
        return BaseService.callAPI('location/add-city', city);
    }

    static async listTimeZones(date) {
        return BaseService.callAPI('location/list-time-zones/' + moment(date).format('YYYY-MM-DD'));
    }

    static async listGeos() {
        return BaseService.callAPI('geo/list');
    }

}